const columns = [
    {
      name: 'WMRC User ID',
      selector: (row) => row?.wmrc_user_id,
      sortable: true,
      sortField: 'wmrc_user_id',
    },
    {
      name: 'WMRC User Name',
      selector: (row) => row?.wmrc_user_name,
      sortable: true,
      sortField: 'wmrc_user_name',
    },
    {
      name: 'Open Incidents',
      selector: (row) => row?.open_incidents,
      sortable: true,
      sortField: 'open_incidents',
    },
  ];
  
 export const mobileColumns = [
  {
    name: 'WMRC User ID',
    selector: (row) => row?.wmrc_user_id,
    sortable: true,
    sortField: 'wmrc_user_id',
  },
  {
    name: 'WMRC User Name',
    selector: (row) => row?.wmrc_user_name,
    sortable: true,
    sortField: 'wmrc_user_name',
  },
  {
    name: 'Open Incidents',
    selector: (row) => row?.open_incidents,
    sortable: true,
    sortField: 'open_incidents',
  },
  ]


  export { columns };
  
